import React from 'react'
import clsx from 'clsx'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import PropTypes from 'prop-types'
import AccountCircle from '@material-ui/icons/AccountCircle'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import { LanguageSelector } from '@i18n'
import UserSettingDialog from '@dialogs/user-setting-dialog'
import OtpViewDialog from '@dialogs/otp-view-dialog'
import SystemTimeChip from '@miscs/system-time-chip'
import hoc from '@hoc'
import { Box, Grid } from '@material-ui/core'
import * as utils from '@utils'

class Header extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'Header')
        }
    }

    state = {
        userMenuAnchorEl: null,
        otpViewShow: false
    }

    openUserMenu = (event) => {
        this.setState({ userMenuAnchorEl: event.currentTarget })
    }

    closeUserMenu = () => {
        this.setState({ userMenuAnchorEl: null })
    }

    closeOtpView = () => {
        this.setState({ otpViewShow: false })
    }

    render() {
        const { classes, auth } = this.props

        return (
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: this.props.sidebarSwitch,
                })}>
                <Toolbar className={classes.toolbar}>
                    <Grid item xs={6}>
                        <Box display="flex" flexDirection="row" justifyContent="flex-start">
                            <IconButton
                                color="inherit"
                                aria-label="Open drawer"
                                onClick={() => this.props.switchSidebar()}
                                edge="start"
                                className={clsx(classes.menuButton)}>
                                <MenuIcon />
                            </IconButton>
                        </Box>
                    </Grid>
                    <Grid item>
                        <Box display="flex" flexDirection="row" justifyContent="center">
                            <img src="/images/LOGO_s01.png" alt="Logo" className={classes.logo} />
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box display="flex" justifyContent="flex-end" alignItems="center">
                            {/* <Box px={2}>
                <MemberOnlineCounterChip />
              </Box> */}
                            <Box px={2}>
                                <SystemTimeChip />
                            </Box>
                            <Box>
                                <LanguageSelector />
                            </Box>
                            <Box>
                                <div onClick={(event) => this.openUserMenu(event)} style={{cursor: 'pointer'}}>
                                    <IconButton
                                        aria-label="Account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        color="inherit">
                                        <AccountCircle />
                                    </IconButton>
                                    {auth.userInfo.account}
                                </div>
                                <Menu
                                    anchorEl={this.state.userMenuAnchorEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    getContentAnchorEl={null}
                                    open={Boolean(this.state.userMenuAnchorEl)}
                                    onClose={this.closeUserMenu}>
                                    <MenuItem
                                        onClick={() => {
                                            this.closeUserMenu()
                                            this.userSettingDialog.OpenDialog()
                                        }}>
                                        {this.t('changePassword')}
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            this.closeUserMenu()
                                            this.setState({ otpViewShow: true })
                                        }}>
                                        {this.t('myOtp')}
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            this.props.authLogout()
                                            this.closeUserMenu()
                                        }}>
                                        {this.t('logOut')}
                                    </MenuItem>
                                </Menu>
                            </Box>
                        </Box>
                    </Grid>
                </Toolbar>
                <UserSettingDialog onRef={(ref) => (this.userSettingDialog = ref)} />
                {this.state.otpViewShow && <OtpViewDialog closeOtpView={this.closeOtpView} />}
            </AppBar>
        )
    }
}

Header.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    switchSidebar: PropTypes.func,
    sidebarSwitch: PropTypes.bool,
    authLogout: PropTypes.func,
    auth: PropTypes.object,
}

const styles = (theme) => {
    return {
        toolbar: { ...theme.mixins.toolbar },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        hide: {
            display: 'none',
        },
        logo: {
            margin: 'auto',
            maxWidth: '180px',
            maxHeight: '50px',
        },
    }
}

export default hoc(styles)(Header)
